import { render, staticRenderFns } from "./addHuis.vue?vue&type=template&id=70a13278"
import script from "./addHuis.vue?vue&type=script&lang=js"
export * from "./addHuis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports